import {SmartComponent} from "smart-component-js";

class HeaderComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.isMenuOpen = false;
        this.init();
    }

    init() {
        this.searchButtons = this.element.querySelectorAll(".header__search-button");
        this.searchButtons.forEach((button) => {
            button.addEventListener("click", () => this.onSearchIconClick());
        });

        this.hamburgerButton = this.element.querySelector(".header__hamburger");
        this.hamburgerIcon = this.hamburgerButton.querySelector(".hamburger-icon");
        this.closeIcon = this.hamburgerButton.querySelector(".close-icon");

        if (this.hamburgerButton) {
            this.hamburgerButton.addEventListener("click", () => this.onHamburgerClick());
            this.hamburgerButton.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.onHamburgerClick();
                }
            });
        }

        window.addEventListener("resize", () => this.onWindowResize());
        this.addUserLoggedListener();
    }


    addUserLoggedListener() {
        const userLoggedButton = this.element.querySelectorAll('.user-logged-button');
        if (!userLoggedButton.length) return;
        const userLayer = this.element.querySelector('.header__user-layer');
        const closeLayer = this.element.querySelector('.header__user-layer-close');

        userLoggedButton.forEach((el) => {
            el.addEventListener('click', () => {
                userLayer.classList.add('visible');
                setTimeout(() => userLayer.classList.add('fade-in'), 20);
            });
        });

        closeLayer.addEventListener('click', () => {
            userLayer.classList.remove('fade-in');
            setTimeout(() => userLayer.classList.remove('visible'), 400);
        });
    }


    onHamburgerClick() {
        this.isMenuOpen = !this.isMenuOpen;

        if (this.isMenuOpen) {
            const overlayEvent = new CustomEvent("show-overlay");
            const menuEvent = new CustomEvent("show-menu");
            document.dispatchEvent(overlayEvent);
            document.dispatchEvent(menuEvent);
        } else {
            const hideOverlayEvent = new CustomEvent("hide-overlay");
            const hideMenuEvent = new CustomEvent("hide-menu");
            document.dispatchEvent(hideOverlayEvent);
            document.dispatchEvent(hideMenuEvent);
        }

        if (window.innerWidth < 768) {
            if (this.isMenuOpen) {
                this.showCloseIcon();
                this.searchButtons.forEach((button) => button.classList.add("hidden"));
            } else {
                this.showHamburgerIcon();
                this.searchButtons.forEach((button) =>
                    button.classList.remove("hidden")
                );
            }
        }
    }

    onWindowResize() {
        if (window.innerWidth >= 768) {
            this.showHamburgerIcon();
            this.searchButtons.forEach((button) => button.classList.remove("hidden"));
        } else {
            if (this.isMenuOpen) {
                this.showCloseIcon();
                this.searchButtons.forEach((button) => button.classList.add("hidden"));
            }
        }
    }

    showCloseIcon() {
        if (this.hamburgerIcon) this.hamburgerIcon.classList.add("hidden");
        if (this.closeIcon) this.closeIcon.classList.remove("hidden");
    }

    showHamburgerIcon() {
        if (this.hamburgerIcon) this.hamburgerIcon.classList.remove("hidden");
        if (this.closeIcon) this.closeIcon.classList.add("hidden");
    }

    onSearchIconClick() {
        this.showSearchOverlay();
    }

    showSearchOverlay() {
        const searchElement = document.querySelector('[component="SearchComponent"]');
        searchElement?.classList.add("visible");
    }
}

export default HeaderComponent;
